import { IDEA_STATUSES } from '@/lib/ideaConstants';
import { cn } from '@/lib/utils';

export const IdeaStatusBadge = ({ status, className }) => {
    const s = IDEA_STATUSES[status] || IDEA_STATUSES.en_attente;
    return (
        <span
            data-testid={`idea-status-badge-${status}`}
            className={cn('inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold', s.badge, className)}
        >
            <span className={cn('h-1.5 w-1.5 rounded-full', s.dot)} />
            {s.label}
        </span>
    );
};

export default IdeaStatusBadge;
